import TimelineView from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Timeline/View';
import SecureFiles from 'Components/ClientApp/CombinedApp/Viewport/SecureFiles';
import HouseholdSimpleActionItem from 'Components/AdvisorApp/Viewport/MeetingSummary/HouseholdSimpleActionItem';
import BestNextStepContainer
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/BestNextStep/Container';

const tabs = [
  {
    name: 'timeline',
    label: 'Timeline',
    component: TimelineView, // TODO: Stop borrowing this tab from Mission Control and make own version.
  },
  {
    name: 'files',
    label: 'Secure Files',
    component: SecureFiles,
  },
  {
    name: 'tasks',
    label: 'Tasks',
    component: HouseholdSimpleActionItem,
  },
  {
    name: 'best-next-step',
    label: 'Best Next Step',
    component: BestNextStepContainer,
  },
];

export default tabs.reduce((acc, curr) => {
  return {
    ...acc,
    [curr.name]: curr,
  };
}, {});
